import React from 'react';
import { ProcessEnvConfig } from 'config/ProcessEnvConfig';
import VisiblePeriodSection from 'components/campaign/campaignCreation/VisiblePeriodSection';
import VisibleMallSection from 'components/campaign/campaignCreation/VisibleMallSection';
import {
  campaignCreationActivePeriodSectionConfig,
  campaignCreationCampaignListingSectionConfig,
  campaignCreationDetailSectionConfig,
  campaignCreationGeneralSectionConfig,
  campaignCreationInstructionSectionConfig,
  campaignCreationKeyVisualSectionConfig,
  campaignCreationRecurringCampaignSections,
  campaignCreationTargetCustomerSectionConfig
} from '../campaignStreamline/CreateCampaignContentPageConfig';
import ReactHookFormSwitch from 'components/reactHookFormComponents/ReactHookFormSwitch';
import LinkedCouponTimeSlotSection from 'components/campaign/campaignCreation/LinkedCouponTimeSlotSection';
import OtherInformationInput from 'components/campaign/campaignCreation/OtherInformationInput';
import { LimitsSplitLine } from '../campaignStreamline/CreateCampaignEarningPageConfig';
import InputFieldControl from 'components/base/InputFieldControl';
import { SectionTopTitle } from 'components/base/CommonComponent';
import EventPreviewContentCard from 'components/Events/EventPreviewContentCard';
import EventPreviewPropertiesCard from 'components/Events/EventPreviewPropertiesCard';
import { CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';
import {
  TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY,
  TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY
} from 'config/PageAnchorConfig/TicketCampaignAnchorConfig';

export const CREATE_EVENT_CONTENT_PAGE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    const isExclusive = watch('isExclusive');
    const excludeBlacklistSegment = watch('excludeBlacklistSegment');
    const haveHomepageBanner = watch('haveHomepageBanner');
    const showInOfferTab = watch('showInOfferTab');
    const isBirthdayRecurringCampaign = watch('isBirthdayRecurringCampaign');

    const targetCustomerSection = campaignCreationGeneralSectionConfig.getDisplayKeys(isExclusive, excludeBlacklistSegment)

    let displayLanguageSectionComponents = [
      ...campaignCreationGeneralSectionConfig.keys,
      ...targetCustomerSection,
      ...campaignCreationKeyVisualSectionConfig.getDisplayKeys(isExclusive),
      ...campaignCreationInstructionSectionConfig.keys,
      ...campaignCreationDetailSectionConfig.keys,
      ...campaignCreationCampaignListingSectionConfig.getDisplayKeys(haveHomepageBanner, showInOfferTab),
      ...(ProcessEnvConfig.haveShopMall ? [CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionContent.visible_mall_key] : []),
      ...campaignCreationActivePeriodSectionConfig.keys,
      CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionContent.visible_period_section_key,
      CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionContent.recurring_birthday_selector_key,
      ...(isBirthdayRecurringCampaign ? [
        CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaignActivePeriod.sectionContent.recurring_birthday_active_period_selector_key,
        CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaignVisiblePeriod.sectionContent.recurring_birthday_visible_period_selector_key,
        CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionContent.recurring_message_selector_key,
      ] : []),
    ];

    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents,
    };
  },
  normalSections: [],
  languageSections: [
    campaignCreationGeneralSectionConfig.section,
    campaignCreationTargetCustomerSectionConfig.section,
    campaignCreationKeyVisualSectionConfig.section,
    campaignCreationInstructionSectionConfig.section,
    campaignCreationDetailSectionConfig.section,
    campaignCreationCampaignListingSectionConfig.section,
    {
      sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey,
      hideInOtherLanguages: true,
      sectionContent: [
        {
          key: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionContent.visible_mall_key,
          component: VisibleMallSection,
        },
      ],
    },
    campaignCreationActivePeriodSectionConfig.section,
    {
      sectionKey: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
      hideInOtherLanguages: true,
      sectionContent: [
        {
          key: CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionContent.visible_period_section_key,
          component: VisiblePeriodSection,
        },
      ],
    },
    ...campaignCreationRecurringCampaignSections
  ],
};

export const CREATE_EVENT_PROPERTIES_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    const fillOtherInformation = watch("fillOtherInfomation");
    const enableLimit = watch("haveLimitsField");
    const requirePointsToRedeem = watch("requirePointsToRedeem");

    let displayNormalSectionComponents = [
      TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.requirePointsToRedeemKey,
      TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.enableOtpKey,
      TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionContent.timeSlotKey,
      TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.fillOtherInformationKey,
      TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.otherInfoInputSectionKey,
      TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.haveLimitsKey
    ];
    let displayLanguageSectionComponents = [];
    if (requirePointsToRedeem) {
      displayNormalSectionComponents.push(
        TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.requiredPointsKey
      )
    }
    if (fillOtherInformation) {
      displayNormalSectionComponents.push(
        TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.otherInfoInputSectionKey
      )
    }
    if (enableLimit) {
      displayNormalSectionComponents.push(
        TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.couponAcquiringLimitKey,
        TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.perHeadLimitKey,
      )
    }
    return {
      displayNormalSectionComponents,
      displayLanguageSectionComponents,
    };
  },
  normalSections: [
    {
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionKey,
      sectionTitle: "requirements",
      sectionContent: [
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.requirePointsToRedeemKey,
          component: ReactHookFormSwitch,
          componentProps: {
            title: 'Points are required to redeem',
            valueFieldName: 'requirePointsToRedeem',
            extraActionOnChange: ({ value, formContext: { setValue }}) => {
              if (value) {
                setValue('enableOtp', true, { shouldDirty: true })
              }
            }
          },
        },
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.requiredPointsKey,
          component: InputFieldControl,
          componentProps: {
            name: 'requiredPoints',
            title: 'Required points',
            useDefaultFieldName: true,
            type: 'number',
            unit: 'points',
            className: 'coupon-campaign-section-input',
          },
        },
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.enableOtpKey,
          complexComponent: ({ formContext: { watch } }) => (
            <ReactHookFormSwitch
              disabled={watch('requirePointsToRedeem')}
              title={'Enable OTP'}
              valueFieldName={'enableOtp'}
              tips={'If toggle off, the ticket acquiring flow could be faster but may have occur abuse or fraud cases (End customer may input an unknown email / mobile number).'}
            />
          )

        },
      ],
    },
    {
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
      sectionTitle: 'Set time Slot by linking the ticket',
      getDisplaySectionDescription: ({ formContext: { watch } }) => {
        const ticketCampaignTimeSlots = watch('ticketCampaignTimeSlots');
        let totalAcquiredCoupon = 0;
        let totalUsedCoupon = 0;
        let totalCouponStock = 0;
        ticketCampaignTimeSlots?.length > 0 &&
          ticketCampaignTimeSlots.forEach(({ couponSet }) => {
            if (couponSet?.totalNumberOfAcquiredCoupons) {
              totalAcquiredCoupon += couponSet.totalNumberOfAcquiredCoupons;
            }
            if (couponSet?.totalNumberOfUsedCoupons) {
              totalUsedCoupon += couponSet.totalNumberOfUsedCoupons;
            }
            if (couponSet?.totalNumberOfGeneratedCoupons) {
              totalCouponStock += couponSet.totalNumberOfGeneratedCoupons;
            }
          });
        return (
          `Total number of tickets from linked ticket set:\n` +
          `Acquired/Used/Total Stock: ${totalAcquiredCoupon}/${totalUsedCoupon}/${totalCouponStock}`
        );
      },
      descriptionClass: 'white-space-pre',
      sectionContent: [
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionContent.timeSlotKey,
          component: LinkedCouponTimeSlotSection,
        },
      ],
    },
    {
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionKey,
      sectionTitle: 'OTHER INFORMATION',
      sectionContent: [
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.fillOtherInformationKey,
          component: ReactHookFormSwitch,
          componentProps: {
            title: 'Fill other information',
            valueFieldName: 'fillOtherInfomation',
          },
        },
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.otherInfoInputSectionKey,
          component: OtherInformationInput,
        },
      ],
    },
    {
      sectionKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionKey,
      sectionTitle: 'LIMITS',
      sectionContent: [
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.haveLimitsKey,
          component: ReactHookFormSwitch,
          componentProps: {
            customTitleClass: "earning-rule-limit-section-title",
            valueFieldName: `haveLimitsField`,
          }
        },
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.couponAcquiringLimitKey,
          complexComponent: () => (
            <>
              <LimitsSplitLine />
              <div style={{ marginTop: "30px" }}>
                <SectionTopTitle title={"Reward acquiring limit"} />
                <ReactHookFormSwitch
                  title='Display the overall limit in the event'
                  valueFieldName='displayOverLimit'
                />
              </div>
            </>
          ),
        },
        {
          key: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.perHeadLimitKey,
          component: InputFieldControl,
          componentProps: {
            name: 'perHeadLimit',
            title:
              'Per head ticket acquiring limit during the event active period',
            useDefaultFieldName: true,
            type: 'number',
            unit: 'number of tickets',
            className: 'coupon-campaign-section-input',
          },
        },
      ],
    },


  ],
  languageSections: []
}


export const CREATE_EVENT_PREVIEW_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents: ["content_section_key", "properties_section_key"]
    };
  },
  normalSections: [],
  languageSections: [
    {
      sectionKey: TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.content.sectionKey,
      sectionContent: [
        {
          key: "content_section_key",
          complexComponent: ({ formContext: { getValues }, language }) => (
            <EventPreviewContentCard
              language={language}
              campaignData={getValues()}
            />
          ),
        },
      ],
    },
    {
      sectionKey: TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.properties.sectionKey,
      sectionTitle: "Rule & properties",
      sectionContent: [
        {
          key: "properties_section_key",
          complexComponent: ({ formContext: { getValues }, language }) => (
            <EventPreviewPropertiesCard
              language={language}
              campaignData={getValues()}
            />
          ),
        },
      ],
    },
  ],
}